import useSWR from "swr";
import { Box } from "@mui/material";
import MarketWatchTopGainers from "../MarketWatchTopGainers";
import { fetchData } from "../../../lib/dashboard/data";

const MarketWatchOptions = () => {
  const { data = [], isLoading } = useSWR("/stock-market/option", fetchData);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "14px",
      }}
    >
      <MarketWatchTopGainers
        title="ارزش آپشن های خرید"
        data={data.call_value_change || []}
        isLoading={isLoading}
        url={"call_value_change"}
        unit={"میلیون تومان"}
      />
      <MarketWatchTopGainers
        title="ارزش آپشن های فروش"
        data={data.put_value_change || []}
        isLoading={isLoading}
        url={"put_value_change"}
        unit={"میلیون تومان"}
      />
      <MarketWatchTopGainers
        title="اسپرد قیمتی آپشن"
        data={data.option_price_spread || []}
        isLoading={isLoading}
        url={"option_price_spread"}
        unit={"درصد"}
      />
    </Box>
  );
};

export default MarketWatchOptions;
